import React from 'react';
import { useI18n } from '../../../../i18n';

import S from './style/ReturnsStatus';

interface ReturnsStatusProps {
  textKeyName: string;
}

const ReturnsStatus: React.FC<ReturnsStatusProps> = ({ textKeyName }) => {
  const i18n = useI18n();

  return (
    <S.Status minHeight="unset" data-cy="returns-status" noIcon copy={textKeyName}>
      <S.StatusText>{i18n`${textKeyName}`}</S.StatusText>
    </S.Status>
  );
};

export default ReturnsStatus;
